import JtlApiClient from "./base";

export const plentyCredentialsApi = {
  // Credentials management
  getCredentials: () => {
    return JtlApiClient.get("/plenty/credentials/");
  },

  createCredential: (data) => {
    return JtlApiClient.post("/plenty/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return JtlApiClient.delete(`/plenty/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return JtlApiClient.put(`/plenty/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return JtlApiClient.post(
      `/plenty/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (data) => {
    return JtlApiClient.post(`/plenty/credentials/test`, data);
  },
};
